import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputAdornment,
	IconButton
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, FormGroup, Alert } from "reactstrap";
import { IoMdSend } from "react-icons/io";
// import { FormControl } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { getOrganizationType } from "../../redux/actions/organizationTypeAction";
import { getBusinessType } from "../../redux/actions/businessTypeAction";
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";
import { getLegalEntity } from "../../redux/actions/legalEntityAction";
import { getWalletAcRequired } from "../../redux/actions/walletAcRequiredAction";
// import { IoIosArrowBack } from "react-icons/io";
import { countries } from "../../utils/countriesDropdown";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import val from "../../getThemeDetails";
import { useHistory } from "react-router-dom";
import FileBase64 from "../../components/Upload/UploadFile";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SaveIcon from "@mui/icons-material/Save";
import { Visibility,VisibilityOff } from "@mui/icons-material";
import BackButton from "../../components/BackButton/BackButton";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
// import {
// 	MuiPickersUtilsProvider,
// 	DatePicker
// } from "@mui/material/pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { districtListPartner } from "../../redux/actions/districtListPartnerAction";
import { divisionListPartner } from "../../redux/actions/divisionListPartnerAction";
import { thanaListPartner } from "../../redux/actions/thanaListPartnerAction";
import { unionListPartner } from "../../redux/actions/unionListPartnerAction";
import { businessNatureSubCategoryTypeUpdate } from "../../redux/actions/businessNatureSubCategoryTypePatnerAction";


//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";


// const IndividualEntity = () => {
const LegalEntity = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	// const regenerateTokenRes = useSelector(
	// 	({ regenerateToken }) => regenerateToken
	// );
	// var authToken = regenerateTokenRes.data.AuthToken;

    
	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
     var authToken = regenerateTokenRes.data.AuthToken;
	var LoginName = partnerloginUser.data.LoginName;
	var LoginRole = partnerloginUser.data.Role;
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	// BusinessType
	const [legalEntityStatus, setLegalEntitystatus] = useState(false);
	const [legalEntityRes, setLegalEntityRes] = useState("");
	const [filePhoto, setFilePhoto] = useState("");

	const [nidFronts, setNidFronts] = useState("");
	const [nidFrontsName, setNidFrontsName] = useState("");

	const [nidBacks, setNidBacks] = useState("");
	const [nidBacksName, setNidBacksName] = useState("");

	const [uploadPhoto, setUploadPhoto] = useState("");
	const [uploadPhotoName, setUploadPhotoName] = useState("");

	const [uploadSignature, setUploadSignature] = useState("");
	const [uploadSignatureName, setUploadSignatureName] = useState("");

	const [hiddenPassword, setHiddenPassword] = useState("true");
	const [hiddenConPassword, setHiddenConPassword] = useState("true");
	const [divisionSetBool, setdivisionSetBool] = useState(false);
	const [divisionDropdownVal, setdivisionDropdownVal] = useState([]);
	const [districtSetBool, setdistrictSetBool] = useState(false);
	const [districtDropdownVal, setdistrictDropdownVal] = useState([]);
	const [thanaSetBool, setthanaSetBool] = useState(false);
	const [thanDropdownVal, setthanDropdownVal] = useState([]);
	const [unionsetBool, setunionsetBool] = useState(false);
	const [unionDropdownVal, setunionDropdownVal] = useState([]);

	// merchant address states
	const [mDivisionSetBool, setmDivisionSetBool] = useState(false);
	const [mDivisionListVal, setmDivisionListVal] = useState([]);
	const [mdistrictBool, setmdistrictBool] = useState(false);
	const [mDistrictListVal, setmDistrictListVal] = useState([]);
	const [mthanaSetBool, setmthanaSetBool] = useState(false);
	const [mthanaListVal, setmthanaListVal] = useState([]);
	const [munionSetBool, setmunionSetBool] = useState(false);
	const [munionListVal, setmunionListVal] = useState([]);

	// business address
	const [bDivisionSetBool, setbDivisionSetBool] = useState(false);
	const [bDivisionListVal, setbDivisionListVal] = useState([]);
	const [bdistrictBool, setbdistrictBool] = useState(false);
	const [bDistrictListVal, setbDistrictListVal] = useState([]);
	const [bthanaSetBool, setbthanaSetBool] = useState(false);
	const [bthanaListVal, setbthanaListVal] = useState([]);
	const [bunionSetBool, setbunionSetBool] = useState(false);
	const [bunionListVal, setbunionListVal] = useState([]);

	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [selectedToDate, setSelectedToDate] = useState(new Date());

	const businessType = useSelector(({ businessType }) => businessType);
	const businessNatureSubCategoryTypeListRes = useSelector(({ businessNatureSubCategoryTypeList }) => businessNatureSubCategoryTypeList);

	const divisionListPartnerRes = useSelector(({ divisionListPartner }) => divisionListPartner);
	const districtListPartnerRes = useSelector(({ districtListPartner }) => districtListPartner);
	const thanaListPartnerRes = useSelector(({ thanaListPartner }) => thanaListPartner);
	const unionListPartnerRes = useSelector(({ unionListPartner }) => unionListPartner);
    const login = useSelector(({login}) => login);
	const setDivisionListFunc = () => {
		if (divisionSetBool) {
			if (divisionListPartnerRes.data.status === 'Success') {
				setdivisionDropdownVal(divisionListPartnerRes.data.list);
			}
			if (divisionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", divisionListPartnerRes.data.description);
				if (
					divisionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					divisionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setDivisionListFunc();
	}, [divisionListPartnerRes.data.status]);


	// business Nature Sub Category Type Update
	const businessNatureSubCategoryTypeUpdateReq = (businessNatureType) => {
		const req = {
			actionCustomerMasterRequestVO: {
				businessNatureType: businessNatureType
			}
		}

		dispatch(businessNatureSubCategoryTypeUpdate(req, authToken))
	}

	const setDistrictListFunc = () => {
		if (districtSetBool) {
			if (districtListPartnerRes.data.status === 'Success') {
				setdistrictDropdownVal(districtListPartnerRes.data.list);
			}
			if (districtListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", districtListPartnerRes.data.description);
				if (
					districtListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					districtListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setDistrictListFunc();
	}, [districtListPartnerRes.data.status]);

	const setThanaListFunc = () => {
		if (thanaSetBool) {
			if (thanaListPartnerRes.data.status === 'Success') {
				setthanDropdownVal(thanaListPartnerRes.data.list);
			}
			if (thanaListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", thanaListPartnerRes.data.description);
				if (
					thanaListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					thanaListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setThanaListFunc();
	}, [thanaListPartnerRes.data.status]);

	const setUnionListFunc = () => {
		if (unionsetBool) {
			if (unionListPartnerRes.data.status === 'Success') {
				setunionDropdownVal(unionListPartnerRes.data.list);
			}
			if (unionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", unionListPartnerRes.data.description);
				if (
					unionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setUnionListFunc()
	}, [unionListPartnerRes.data.status])

	const setmDivisionListFunc = () => {
		if (mDivisionSetBool) {
			if (divisionListPartnerRes.data.status === 'Success') {
				setmDivisionListVal(divisionListPartnerRes.data.list);
			}
			if (divisionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", divisionListPartnerRes.data.description);
				if (
					divisionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					divisionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setmDivisionListFunc();
	}, [divisionListPartnerRes.data.status]);

	const setmDistrictListFunc = () => {
		if (mdistrictBool) {
			if (districtListPartnerRes.data.status === 'Success') {
				setmDistrictListVal(districtListPartnerRes.data.list);
			}
			if (districtListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", districtListPartnerRes.data.description);
				if (
					districtListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					districtListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setmDistrictListFunc();
	}, [districtListPartnerRes.data.status]);

	const setmThanaListFunc = () => {
		if (mthanaSetBool) {
			if (thanaListPartnerRes.data.status === 'Success') {
				setmthanaListVal(thanaListPartnerRes.data.list);
			}
			if (thanaListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", thanaListPartnerRes.data.description);
				if (
					thanaListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					thanaListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setmThanaListFunc();
	}, [thanaListPartnerRes.data.status]);

	const setmUnionListFunc = () => {
		if (munionSetBool) {
			if (unionListPartnerRes.data.status === 'Success') {
				setmunionListVal(unionListPartnerRes.data.list);
			}
			if (unionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", unionListPartnerRes.data.description);
				if (
					unionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setmUnionListFunc()
	}, [unionListPartnerRes.data.status]);

	const setbDivisionListFunc = () => {
		if (bDivisionSetBool) {
			if (divisionListPartnerRes.data.status === 'Success') {
				setbDivisionListVal(divisionListPartnerRes.data.list);
			}
			if (divisionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", divisionListPartnerRes.data.description);
				if (
					divisionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					divisionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setbDivisionListFunc();
	}, [divisionListPartnerRes.data.status]);

	const setbDistrictListFunc = () => {
		if (bdistrictBool) {
			if (districtListPartnerRes.data.status === 'Success') {
				setbDistrictListVal(districtListPartnerRes.data.list);
			}
			if (districtListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", districtListPartnerRes.data.description);
				if (
					districtListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					districtListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setbDistrictListFunc();
	}, [districtListPartnerRes.data.status]);

	const setbThanaListFunc = () => {
		if (bthanaSetBool) {
			if (thanaListPartnerRes.data.status === 'Success') {
				setbthanaListVal(thanaListPartnerRes.data.list);
			}
			if (thanaListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", thanaListPartnerRes.data.description);
				if (
					thanaListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					thanaListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setbThanaListFunc();
	}, [thanaListPartnerRes.data.status]);

	const setbUnionListFunc = () => {
		if (bunionSetBool) {
			if (unionListPartnerRes.data.status === 'Success') {
				setbunionListVal(unionListPartnerRes.data.list);
			}
			if (unionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", unionListPartnerRes.data.description);
				if (
					unionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setbUnionListFunc()
	}, [unionListPartnerRes.data.status])

	const handleAttachmentsDoc = (e, nidFronts) => {
		if (nidFronts == "nidFronts") {
			setNidFronts(e.base64);
			setNidFrontsName(e.name);
		} else if (nidFronts == "nidBacks") {
			setNidBacks(e.base64);
			setNidBacksName(e.name);
		} else if (nidFronts == "uploadPhoto") {
			setUploadPhoto(e.base64);
			setUploadPhotoName(e.name);
		} else if (nidFronts == "uploadSignature") {
			setUploadSignature(e.base64);
			setUploadSignatureName(e.name);
		}
	};

	const businessTypes = () => {
		const BusinessType = {
			partner: {
				partnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(getBusinessType(BusinessType, authToken));
	};

	// OrganizationType

	const organizationType = useSelector(
		({ organizationType }) => organizationType
	);

	const organizationTypes = () => {
		const OrganizationType = {
			partner: {
				partnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(getOrganizationType(OrganizationType, authToken));
	};

	// WalletACRequired

	const walletAcRequired = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);

	const walletAcRequire = () => {
		const WalletAcRequired = {
			authentication: {
				partnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(getWalletAcRequired(WalletAcRequired, authToken));
	};

	// DefaultCurrencyList

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			defaultCurrencyList();
			walletAcRequire();
			businessTypes();
			organizationTypes();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const defaultCurrencyList = () => {
		const DefaultCurrencyList = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				role : login.data.subRole,
			}
		};

		return dispatch(getDefaultCurrencyList(DefaultCurrencyList, authToken));
	};

	const [user, setUser] = useState({
		userName: "",
		password: "",
		confirmPassword: "",
		role: "",
		organizationName: "",
		siteURL: "",
		domain: "",
		whiteList: "",
		businessNumber: "",
		RSMNumber: "",
		ASMNumber: "",
		TMNumber: "",
		VatId: "",
		TaxId: "",
		tradeLicense: "",
		tradeLicenseAuthority: "",
		tradeLicensecValidity: "",
		organizationTypee: "",
		businessTypee: "",
		businessNatureTypee: "",
		bankName: "",
		branchName: "",
		accountHolderName: "",
		accountNumber: "",
		outletInfra: "",
		outletInfraOwnership: "",
		currency: "",
		country: "",
		MOcountry: "",
		Bcountry: "",
		MerchantOwnerAddress: "",
		state: "",
		Bstate: "",
		city: "",
		Bcity: "",
		postalCode: "",
		BpostalCode: "",
		businessAddress: "",
		locationType: "",
		contactPersonName: "",
		phone: "",
		dob: "",
		spouseName: "",
		motherName: "",
		idType: "",
		idNumber: "",
		nidFront: "",
		nidBack: "",
		photo: "",
		signature: "",
		email: "",
		gender: "",
		nomineeName: "",
		nomineePhone: "",
		nomineeRelation: "",
		division: '',
		district: '',
		thana: '',
		union: '',
		stateInp: '',
		merchantCity: '',
		postalCode: '',
		mdivision: '',
		mdistrict: '',
		mthana: '',
		munion: '',
		mstate: '',
		mcity: '',
		mpostalCode: '',
		bdivision: '',
		bdistrict: '',
		bthana: '',
		bunion: '',
		bstate: '',
		bcity: '',
		bpostalCode: '',
	});

	const {
		userName,
		password,
		confirmPassword,
		role,
		organizationName,
		siteURL,
		domain,
		whiteList,
		businessNumber,
		RSMNumber,
		ASMNumber,
		TMNumber,
		VatId,
		TaxId,
		tradeLicense,
		tradeLicenseAuthority,
		tradeLicensecValidity,
		organizationTypee,
		businessTypee,
		businessNatureTypee,
		bankName,
		branchName,
		accountHolderName,
		accountNumber,
		outletInfra,
		outletInfraOwnership,
		currency,
		country,
		MOcountry,
		Bcountry,
		MerchantOwnerAddress,
		state,
		Bstate,
		city,
		Bcity,
		postalCode,
		BpostalCode,
		businessAddress,
		locationType,
		contactPersonName,
		phone,
		dob,
		spouseName,
		motherName,
		idType,
		idNumber,
		nidFront,
		nidBack,
		photo,
		signature,
		email,
		gender,
		nomineeName,
		nomineePhone,
		nomineeRelation,
		division,
		district,
		thana,
		union,
		stateInp,
		merchantCity,
		merchantPostalCode,
		mdivision,
		mdistrict,
		mthana,
		munion,
		mstate,
		mcity,
		mpostalCode,
		bdivision,
		bdistrict,
		bthana,
		bunion,
		bstate,
		bcity,
		bpostalCode,
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = value.trim()
			// obj[name] = Util.noWhiteSpace(value.trim()) ? value.trim() : obj[name];
		}

		if (name === 'country') {
			obj.division = '';
			obj.district = '';
			obj.thana = '';
			obj.union = '';
			obj.stateInp = '';
			obj.merchantCity = '';
			obj.merchantPostalCode = '';
		}

		if (name === 'MOcountry') {
			obj.mdivision = '';
			obj.mdistrict = '';
			obj.mthana = '';
			obj.munion = '';
			obj.mstate = '';
			obj.mcity = '';
			obj.mpostalCode = '';
		}

		if (name === 'Bcountry') {
			obj.bdivision = '';
			obj.bdistrict = '';
			obj.bthana = '';
			obj.bunion = '';
			obj.bstate = '';
			obj.bcity = '';
			obj.bpostalCode = '';
		}

		setUser(obj);
		if (name == "businessTypee") {
			setUser({ ...user, [name]: value })
		} else if (name == "businessNatureTypee") {
			setUser({ ...user, [name]: value })
		}
	};

	const legalEntity = useSelector(({ legalEntity }) => legalEntity);

	const LegalEntityy = () => {
		const req = {
			loginDetails: {
				loginName: LoginName,
				loginRole: LoginRole,
				walletOwnerId: val.walletOwnerId
			},
			legalEntityRequestVO: {
				userEmail: userName,
				password: password,
				confPassword: confirmPassword,
				accountType: role == "Select Role" ? "" : role,
				organizationName: organizationName,
				site: siteURL,
				domain: domain,
				whiteListIPAddress: whiteList,
				businessPhoneNo: businessNumber,
				rsmPhoneNo: RSMNumber,
				asmPhoneNo: ASMNumber,
				tmPhoneNo: TMNumber,
				vatId: VatId,
				taxId: TaxId,
				tradeLicenseNo: tradeLicense,
				tradeLicenseAuthority: tradeLicenseAuthority,
				tradeLicenseValidity: moment(selectedToDate).format("DD/MM/YYYY"),
				organizationType:
					organizationTypee == "Select OrganizationTypee"
						? ""
						: organizationTypee,
				businessType:
					businessTypee == "Select BusinessTypee" ? "" : businessTypee,
				businessSubCategory: user.businessNatureTypee,
				bankName: bankName,
				branchName: branchName,
				accountHolderName: accountHolderName,
				accountNumber: accountNumber,
				outletInfra: outletInfra,
				outletInfraOwnership:
					outletInfraOwnership == "Select OutletInfraOwnership"
						? ""
						: outletInfraOwnership,
				currency: currency == "Select Currency" ? "" : currency,
				// country: "India-91",
				country: country == "Select Country" ? "" : country,
				division: division === 'Select Divison' ? '' : division,
				district: district === 'Select District' ? '' : district,
				thana: thana === 'Select thana' ? '' : thana,
				union: union === 'Select union' ? '' : union,
				state: stateInp,
				city: merchantCity,
				postalCode: merchantPostalCode,
				merchantAddressRequestVO: {
					merchantOwnerAddress: MerchantOwnerAddress,
					// state: state,
					// city: city,
					country: MOcountry == "Select MOcountry" ? "" : MOcountry,
					// country: "India-91",
					// postalCode: postalCode,
					division: mdivision,
					district: mdistrict,
					thana: mthana,
					union: munion,
					state: mstate,
					city: mcity,
					postalCode: mpostalCode,
				},
				businessAddressRequestVO: {
					businessAddress: businessAddress,
					locationType:
						locationType == "Select LocationType" ? "" : locationType,
					state: bstate,
					city: bcity,
					country: Bcountry == "Select Bcountry" ? "" : Bcountry,
					postalCode: bpostalCode,
					division: bdivision,
					district: bdistrict,
					thana: bthana,
					union: bunion,
				},
				contactPersonDetailsVO: {
					contactPersonName: contactPersonName,
					phoneNumber: phone,
					dateOfBirth: moment(selectedDate).format("DD/MM/YYYY"),
					fatherORSpouseName: spouseName,
					motherName: motherName,
					iDType: idType,
					iDNumber: idNumber,
					//  uploadNIDFront: nidFront,
					uploadNIDFront: nidFronts.split(",")[1],
					// uploadNIDBack: nidBack,
					uploadNIDBack: nidBacks.split(",")[1],
					// uploadPhoto: photo,
					uploadPhoto: uploadPhoto.split(",")[1],
					// uploadSignature: signature,
					uploadSignature: uploadSignature.split(",")[1],
					email: email,
					gender: gender == "Select Gender" ? "" : gender
				},
				NomineeDetailsVO: {
					nomineeName: nomineeName,
					nomineePhoneNumber: nomineePhone,
					nomineeRelationship: nomineeRelation
				}
			}
		};
		dispatch(getLegalEntity(req, authToken));
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const submitClick = (e) => {
		e.preventDefault();
		LegalEntityy();
		setLegalEntitystatus(true);
		// if (legalEntity.success) {
		//   swalWithBootstrapButtons.fire({
		//     type: "success",
		//     title: "Legal Entity set Successfully",
		//   });
		//   LegalE();
		// } else {
		//   swalWithBootstrapButtons.fire({
		//     type: "error",
		//     title: "Something Went Wrong",
		//   });
		// }
	};

	useEffect(() => {
		if (legalEntityStatus) {
			if (legalEntity.data.status == "Success") {
				setLegalEntityRes(legalEntity.data.status);
				setNotificationOpen(true);
				// swalWithBootstrapButtons.fire({
				//   type: "success",
				//   title: "IndividualEntity set Successfully",
				// });
			}
			if (legalEntity.data.status == "failed") {
				setLegalEntityRes(legalEntity.data.status);
				setNotificationOpen(true);
				if (
					legalEntity.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					legalEntity.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				// swalWithBootstrapButtons.fire({
				//   type: "error",
				//   title: "Something went Wrong",
				// });
			}

			if (legalEntity.data.status == "Failed") {
				setLegalEntityRes(legalEntity.data.status);
				setNotificationOpen(true);
				if (
					legalEntity.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					legalEntity.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				// swalWithBootstrapButtons.fire({
				//   type: "error",
				//   title: "Something went Wrong",
				// });
			}
		}
	}, [legalEntity.data.status]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const LegalE = () => {
		// history.push({
		//   pathname: `/index/profile`,
		//   search: `?userId = ${id}`,
		// });
		history.push("/index/customer-master");
	};

	const togglePassword = (e) => {
		e.preventDefault();
		setHiddenPassword((state) => !state);
	};

	const toggleConPassword = (e) => {
		e.preventDefault();
		setHiddenConPassword((state) => !state);
	};

	useEffect(() => {
		if (country.includes('Bangladesh')) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(divisionListPartner(req, authToken));
			setdivisionSetBool(true);
		}
	}, [country]);

	useEffect(() => {
		if (division) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: division
				}
			}
			dispatch(districtListPartner(req, authToken));
			setdistrictSetBool(true);
		}
	}, [division]);

	useEffect(() => {
		if (district) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district
				}
			}
			dispatch(thanaListPartner(req, authToken));
			setthanaSetBool(true);
		}
	}, [district]);

	useEffect(() => {
		if (thana) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district,
					thana: thana
				}
			}
			dispatch(unionListPartner(req, authToken));
			setunionsetBool(true);
		}
	}, [thana]);

	useEffect(() => {
		if (MOcountry.includes('Bangladesh')) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(divisionListPartner(req, authToken));
			setmDivisionSetBool(true);
		}
	}, [MOcountry]);

	useEffect(() => {
		if (mdivision) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: mdivision
				}
			}
			dispatch(districtListPartner(req, authToken));
			setmdistrictBool(true);
		}
	}, [mdivision]);

	useEffect(() => {
		if (mdistrict) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: mdistrict
				}
			}
			dispatch(thanaListPartner(req, authToken));
			setmthanaSetBool(true);
		}
	}, [mdistrict]);

	useEffect(() => {
		if (mthana) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district,
					thana: mthana
				}
			}
			dispatch(unionListPartner(req, authToken));
			setmunionSetBool(true);
		}
	}, [mthana]);

	useEffect(() => {
		if (Bcountry.includes('Bangladesh')) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(divisionListPartner(req, authToken));
			setbDivisionSetBool(true);
		}
	}, [Bcountry]);

	useEffect(() => {
		if (bdivision) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: bdivision
				}
			}
			dispatch(districtListPartner(req, authToken));
			setbdistrictBool(true);
		}
	}, [bdivision]);

	useEffect(() => {
		if (bdistrict) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: bdistrict
				}
			}
			dispatch(thanaListPartner(req, authToken));
			setbthanaSetBool(true);
		}
	}, [bdistrict]);

	useEffect(() => {
		if (bthana) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district,
					thana: bthana
				}
			}
			dispatch(unionListPartner(req, authToken));
			setbunionSetBool(true);
		}
	}, [bthana]);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}>
							{/* <Button
                // onClick={backClick}
                onClick={LegalE}
                startIcon={<IoIosArrowBack />}
                variant="text"
                color="primary"
              >
                Go Back
              </Button> */}
						</Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					{/* <hr /> */}
					<br />
					<Grid container>
						<Grid item lg={12} md={12} sm={12}>
							<h6
								align="center"
								className="text-center themeText"
							
							// style={{ marginTop: "1.2rem", marginRight: "3rem" }}
							>
								{" "}
								ADD LEGAL ENTITY
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											type="email"
											size="small"
											color="primary"
											autoFocus={true}
											label="Username"
											fullWidth={true}
											name="userName"
											id="firstName"
											value={userName}
											onChange={(e) => onInputChange(e)}
											variant="standard"
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
											type={hiddenPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Password"
											fullWidth={true}
											name="password"
											id="lastName"
											value={password}
											onChange={(e) => onInputChange(e)}
											variant="standard"
											error={
												(password.length > 0 && password.length < 8) ? (
													<p className="passwordNotMatch" style={{ color: "red" }}>
														{password.length > 0
															? "Password should be at least 8 characters"
															: ""}
													</p>
												) : (
													""
												)
											}

											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={togglePassword}
															onMouseDown={togglePassword}
														>
															{hiddenPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Should be same as Password)"
											type={hiddenConPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Confirm Password"
											fullWidth={true}
											name="confirmPassword"
											id="lastName"
											value={confirmPassword}
											onChange={(e) => onInputChange(e)}
											variant="standard"
											error={
												password &&
													password !== confirmPassword &&
													confirmPassword ? (
													<p
														className="passwordNotMatch"
														style={{ color: "red" }}
													>
														{"Password did not match"}
													</p>
												) : (
													""
												)
											}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={toggleConPassword}
															onMouseDown={toggleConPassword}
														>
															{hiddenConPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="Role"
									fullWidth={true}
									name="role"
									// value={role}
									defaultValue={"Select Role" || role}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									{walletAcRequired.success &&
										[].concat(walletAcRequired.data.rolesList).map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</div>
							<div style={{ marginTop: "3.5rem", marginBottom: "1.5rem" }}>
								<Alert
									className="text-center tableHeaderColor"
									variant="secondary"
								// fullWidth={true}
								// style={{ backgroundColor: "#00b9f5" }}
								>
									<Typography variant="body1"
									className="tableHeaderColor"
									
									>Merchant Information</Typography>
								</Alert>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									size="small"
									color="primary"
									label="Organization Name"
									fullWidth={true}
									name="organizationName"
									value={organizationName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									required
									color="primary"
									label="Site URL: (Ex. http://www.abc.com)"
									fullWidth={true}
									name="siteURL"
									value={siteURL}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									required
									color="primary"
									label="Domain: (Ex. http://www.abc.com)"
									fullWidth={true}
									name="domain"
									value={domain}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								></TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									size="small"
									color="primary"
									label="Whitelist IP Address"
									fullWidth={true}
									name="whiteList"
									value={whiteList}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									size="small"
									color="primary"
									label="Busines Phone Number"
									fullWidth={true}
									name="businessNumber"
									value={businessNumber}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									required
									label="RSM Phone Number"
									fullWidth={true}
									name="RSMNumber"
									value={RSMNumber}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									size="small"
									color="primary"
									required
									label="ASM Phone Number"
									fullWidth={true}
									name="ASMNumber"
									value={ASMNumber}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									size="small"
									color="primary"
									label="TM Phone Number"
									fullWidth={true}
									name="TMNumber"
									value={TMNumber}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									size="small"
									color="primary"
									label="VAT ID"
									fullWidth={true}
									name="VatId"
									value={VatId}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="TAX ID"
									fullWidth={true}
									name="TaxId"
									value={TaxId}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Trade License No"
									fullWidth={true}
									name="tradeLicense"
									value={tradeLicense}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Trade License Authority"
									fullWidth={true}
									name="tradeLicenseAuthority"
									value={tradeLicenseAuthority}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								{/* <TextField
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Trade License Validity"
                  fullWidth={true}
                  name="tradeLicensecValidity"
                  value={tradeLicensecValidity}
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
									
									
										<DatePicker
											label="Trade License Validity"
											format="MM/dd/yyyy"
											value={selectedToDate}
											onChange={handleToDateChange}
											disableFuture={false}
											disablePast
										/>
									 </LocalizationProvider>
								</FormControl>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Organization Type"
									fullWidth={true}
									name="organizationTypee"
									// value={organizationTypee}
									defaultValue={"Select Organization Type" || organizationTypee}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem
										value="Select Organization Type"
										selected="Select Organization Type"
									>
										Select Organization Type
									</MenuItem>
									{organizationType.success &&
										[].concat(organizationType.data.rolesList).map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Business Type"
									fullWidth={true}
									name="businessTypee"
									// value={businessTypee}
									defaultValue={"Select Business Type" || businessTypee}
									onChange={(e) => {
										onInputChange(e);
										businessNatureSubCategoryTypeUpdateReq(e.target.value);
									}}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem
										value="Select Business Type"
										selected="Select Business Type"
									>
										Select Business Type
									</MenuItem>
									{businessType.success &&
										[].concat(businessType.data.rolesList).map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Business Nature Type"
									fullWidth={true}
									name="businessNatureTypee"
									defaultValue={"Select Business Nature Type" || businessNatureTypee}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem
									// value="Select Business Nature Type"
									// selected="Select Business Nature Type"
									>
										Select Business Nature Type
									</MenuItem>

									{businessNatureSubCategoryTypeListRes.data.status &&
										[].concat(businessNatureSubCategoryTypeListRes.data.businessSubCategory).map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Bank Name"
									fullWidth={true}
									name="bankName"
									value={bankName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Branch Name"
									fullWidth={true}
									name="branchName"
									value={branchName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Account Holder Name"
									fullWidth={true}
									name="accountHolderName"
									value={accountHolderName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Account Number"
									fullWidth={true}
									name="accountNumber"
									value={accountNumber}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Outlet Infra"
									fullWidth={true}
									name="outletInfra"
									value={outletInfra}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									select
									size="small"
									color="primary"
									label="Outlet Infra Ownership"
									fullWidth={true}
									name="outletInfraOwnership"
									// value={outletInfraOwnership}
									defaultValue={
										"Select Outlet Infra Ownership" || outletInfraOwnership
									}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									{" "}
									<MenuItem
										value="Select Outlet Infra Ownership"
										selected="Select Outlet Infra Ownership"
									>
										Select Outlet Infra Ownership
									</MenuItem>
									<MenuItem value="Leased">Leased</MenuItem>
									<MenuItem value="Owned">Owned</MenuItem>
									<MenuItem value="Rental">Rental</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									select
									size="small"
									required
									color="primary"
									label="Currency"
									fullWidth={true}
									name="currency"
									// value={currency}
									defaultValue={"Select Currency" || currency}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>
									{adminCurrencyList.success &&
										[]
											.concat(adminCurrencyList.data.currencyList)
											.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Country"
									fullWidth={true}
									name="country"
									// value={country}
									defaultValue={"Select Country" || country}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>
									{countries.map((value) => (
										<MenuItem value={value.label + value.dial_code}>
											{value.label}
										</MenuItem>
									))}
								</TextField>
							</div>
							{
								country.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Division"
												fullWidth={true}
												name="division"
												defaultValue={division || "Select Divison"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											>
												<MenuItem value="Select Divison" selected="Select Divison">
													Select Division
												</MenuItem>
												{
													divisionDropdownVal && [].concat(divisionDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="District"
												fullWidth={true}
												name="district"
												defaultValue={district || "Select District"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											>
												<MenuItem value="Select District" selected="Select District">
													Select District
												</MenuItem>
												{
													districtDropdownVal && [].concat(districtDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Thana"
												fullWidth={true}
												name="thana"
												defaultValue={thana || "Select thana"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											>
												<MenuItem value="Select thana" selected="Select thana">
													Select thana
												</MenuItem>
												{
													thanDropdownVal && [].concat(thanDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Union"
												fullWidth={true}
												name="union"
												defaultValue={union || "Select union"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											>
												<MenuItem value="Select union" selected="Select union">
													Select union
												</MenuItem>
												{
													unionDropdownVal && [].concat(unionDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
									</>
								)
							}
							{
								country && !country.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="State"
												fullWidth={true}
												name="stateInp"
												value={stateInp}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											/>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="City"
												fullWidth={true}
												name="merchantCity"
												value={merchantCity}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											/>
										</div>

										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="Postal Code"
												fullWidth={true}
												name="merchantPostalCode"
												value={merchantPostalCode}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
												InputProps={{
													sx: {
													  "&:before": { borderBottomColor: "gray" }, // before focus
													  "&:after": { borderBottomColor: "gray" },  // after focus
													},
												  }}
												  InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												  }}
											/>
										</div>
									</>
								)
							}
							<div style={{ marginTop: "3.5rem", marginBottom: "1.5rem" }}>
								<Alert
									className="text-center tableHeaderColor"
									variant="secondary"
								// fullWidth={true}
								// style={{ backgroundColor: "#00b9f5" }}
								>
									<Typography variant="body1"
									className="tableHeaderColor"
									
									>
										Merchant Owner Address
									</Typography>
								</Alert>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									size="small"
									color="primary"
									label="Merchant Owner Address"
									fullWidth={true}
									name="MerchantOwnerAddress"
									value={MerchantOwnerAddress}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							{/* <div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="State"
									fullWidth={true}
									name="state"
									value={state}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="City"
									fullWidth={true}
									name="city"
									value={city}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
								/>
							</div> */}
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Country"
									fullWidth={true}
									name="MOcountry"
									// value={MOcountry}
									defaultValue={"Select Country" || MOcountry}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>
									{countries.map((value) => (
										<MenuItem value={value.label + value.dial_code}>
											{value.label}
										</MenuItem>
									))}
								</TextField>
							</div>
							{
								MOcountry.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Division"
												fullWidth={true}
												name="mdivision"
												defaultValue={mdivision || "Select Divison"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select Divison" selected="Select Divison">
													Select Division
												</MenuItem>
												{
													mDivisionListVal && [].concat(mDivisionListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="District"
												fullWidth={true}
												name="mdistrict"
												defaultValue={mdistrict || "Select District"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select District" selected="Select District">
													Select District
												</MenuItem>
												{
													mDistrictListVal && [].concat(mDistrictListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Thana"
												fullWidth={true}
												name="mthana"
												defaultValue={mthana || "Select thana"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select thana" selected="Select thana">
													Select thana
												</MenuItem>
												{
													mthanaListVal && [].concat(mthanaListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Union"
												fullWidth={true}
												name="munion"
												defaultValue={munion || "Select union"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select union" selected="Select union">
													Select union
												</MenuItem>
												{
													munionListVal && [].concat(munionListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
									</>
								)
							}
							{
								MOcountry && !MOcountry.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="State"
												fullWidth={true}
												name="mstate"
												value={mstate}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="City"
												fullWidth={true}
												name="mcity"
												value={mcity}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>

										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="Postal Code"
												fullWidth={true}
												name="mpostalCode"
												value={mpostalCode}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>
									</>
								)
							}
							<div style={{ marginTop: "3.5rem", marginBottom: "1.5rem" }}>
								<Alert
									className="text-center tableHeaderColor"
									variant="secondary"
								// fullWidth={true}
								// style={{ backgroundColor: "#00b9f5" }}
								>
									<Typography variant="body1"
									className="tableHeaderColor"
									
									>Business Address</Typography>
								</Alert>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									size="small"
									color="primary"
									label="Business Address"
									fullWidth={true}
									name="businessAddress"
									value={businessAddress}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									select
									size="small"
									color="primary"
									label="Location Type"
									fullWidth={true}
									name="locationType"
									// value={locationType}
									defaultValue={"Select Location Type" || locationType}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									{" "}
									<MenuItem
										value="Select Location Type"
										selected="Select Location Type"
									>
										Select Location Type
									</MenuItem>
									<MenuItem value="Metro">Metro</MenuItem>
									<MenuItem value="Urban">Urban</MenuItem>
									<MenuItem value="Rural">Rural</MenuItem>
								</TextField>
							</div>
							{/* <div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="State"
									fullWidth={true}
									name="Bstate"
									value={Bstate}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="City"
									fullWidth={true}
									name="Bcity"
									value={Bcity}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div> */}
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Country"
									fullWidth={true}
									name="Bcountry"
									// value={Bcountry}
									defaultValue={"Select Country" || Bcountry}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>
									{countries.map((value) => (
										<MenuItem value={value.label + value.dial_code}>
											{value.label}
										</MenuItem>
									))}
								</TextField>
							</div>
							{
								Bcountry.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Division"
												fullWidth={true}
												name="bdivision"
												defaultValue={bdivision || "Select Divison"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select Divison" selected="Select Divison">
													Select Division
												</MenuItem>
												{
													bDivisionListVal && [].concat(bDivisionListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="District"
												fullWidth={true}
												name="bdistrict"
												defaultValue={bdistrict || "Select District"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select District" selected="Select District">
													Select District
												</MenuItem>
												{
													bDistrictListVal && [].concat(bDistrictListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Thana"
												fullWidth={true}
												name="bthana"
												defaultValue={bthana || "Select thana"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select thana" selected="Select thana">
													Select thana
												</MenuItem>
												{
													bthanaListVal && [].concat(bthanaListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Union"
												fullWidth={true}
												name="bunion"
												defaultValue={bunion || "Select union"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select union" selected="Select union">
													Select union
												</MenuItem>
												{
													bunionListVal && [].concat(bunionListVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
									</>
								)
							}
							{
								Bcountry && !Bcountry.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="State"
												fullWidth={true}
												name="bstate"
												value={bstate}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="City"
												fullWidth={true}
												name="bcity"
												value={bcity}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>

										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="Postal Code"
												fullWidth={true}
												name="bpostalCode"
												value={bpostalCode}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>
									</>
								)
							}
							{/* <div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Postal Code"
									fullWidth={true}
									name="BpostalCode"
									value={BpostalCode}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
								/>
							</div> */}
							<div style={{ marginTop: "3.5rem", marginBottom: "1.5rem" }}>
								<Alert
									className="text-center tableHeaderColor"
									variant="secondary"
								// fullWidth={true}
								// style={{ backgroundColor: "#00b9f5" }}
								>
									<Typography variant="body1"
									className="tableHeaderColor"
									
									>
										Contact Person Details
									</Typography>
								</Alert>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									size="small"
									color="primary"
									label="Contact Person Name"
									fullWidth={true}
									name="contactPersonName"
									value={contactPersonName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									size="small"
									color="primary"
									label="Phone Number (with country code)"
									fullWidth={true}
									name="phone"
									value={phone}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								{/* <TextField
                  required
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="DOB"
                  fullWidth={true}
                  name="dob"
                  value={dob}
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
									
										<DatePicker
											label="DOB"
											format="MM/dd/yyyy"
											name="selectedDate"
											value={selectedDate}
											onChange={handleDateChange}
											disableFuture={true}
										/>
									 </LocalizationProvider>
								</FormControl>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Father/Spouse Name"
									fullWidth={true}
									name="spouseName"
									value={spouseName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="Mother Name"
									fullWidth={true}
									name="motherName"
									value={motherName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="ID TYPE"
									fullWidth={true}
									name="idType"
									value={idType}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									label="ID Number"
									fullWidth={true}
									name="idNumber"
									value={idNumber}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload NID Front
								</Typography>
								{/* <input
                  name="nidFront"
                  value={nidFront}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "nidFronts")}
									showUploadList={false}
									value={nidFrontsName}
								/>
								{nidFrontsName ? nidFrontsName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload NID Back
								</Typography>
								{/* <input
                  name="nidback"
                  value={nidBack}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard1"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "nidBacks")}
									showUploadList={false}
									value={nidBacksName}
								/>
								{nidBacksName ? nidBacksName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload Photo
								</Typography>
								{/* <input
                  name="photo"
                  value={photo}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard2"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "uploadPhoto")}
									showUploadList={false}
									value={uploadPhotoName}
								/>
								{uploadPhotoName ? uploadPhotoName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography variant="body1" align="justify" gutterBottom={true}>
									Upload Signature:
								</Typography>
								{/* <input
                  name="signature"
                  value={signature}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard3"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "uploadSignature")}
									showUploadList={false}
									value={uploadSignatureName}
								/>
								{uploadSignatureName ? uploadSignatureName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									type="email"
									label="Email ID"
									fullWidth={true}
									name="email"
									value={email}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										select
										size="small"
										color="primary"
										label="Gender"
										fullWidth={true}
										name="gender"
										// value={gender}
										defaultValue={"Select Gender" || gender}
										onChange={(e) => onInputChange(e)}
										variant="standard"
										InputProps={{
											sx: {
											  "&:before": { borderBottomColor: "gray" }, // before focus
											  "&:after": { borderBottomColor: "gray" },  // after focus
											},
										  }}
										  InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										  }}
									>
										{" "}
										<MenuItem value="Select Gender" selected="Select Gender">
											Select Gender
										</MenuItem>
										<MenuItem value="Male">Male</MenuItem>
										<MenuItem value="Female">Female</MenuItem>
										<MenuItem value="Transgender">Other</MenuItem>
									</TextField>
								</div>
								<div style={{ marginTop: "3.5rem", marginBottom: "1.5rem" }}>
									<Alert
										className="text-center tableHeaderColor"
										variant="secondary"
									// fullWidth={true}
									// style={{ backgroundColor: "#00b9f5" }}
									>
										<Typography variant="body1"
									className="tableHeaderColor"
										
										>Nominee Information</Typography>
									</Alert>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										label="Nominee Name"
										fullWidth={true}
										name="nomineeName"
										value={nomineeName}
										// onChange={(e) => onInputChange(e)}
										onChange={(e) => onInputChange(e, "alphabet")}
										variant="standard"
										InputProps={{
											sx: {
											  "&:before": { borderBottomColor: "gray" }, // before focus
											  "&:after": { borderBottomColor: "gray" },  // after focus
											},
										  }}
										  InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										  }}
									/>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										label="Nominee Phone Number"
										fullWidth={true}
										name="nomineePhone"
										value={nomineePhone}
										// onChange={(e) => onInputChange(e)}
										onChange={(e) => onInputChange(e, "number")}
										variant="standard"
										InputProps={{
											sx: {
											  "&:before": { borderBottomColor: "gray" }, // before focus
											  "&:after": { borderBottomColor: "gray" },  // after focus
											},
										  }}
										  InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										  }}
									/>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										label="Nominee's Relationship"
										fullWidth={true}
										name="nomineeRelation"
										value={nomineeRelation}
										// onChange={(e) => onInputChange(e)}
										onChange={(e) => onInputChange(e, "alphabet")}
										variant="standard"
										InputProps={{
											sx: {
											  "&:before": { borderBottomColor: "gray" }, // before focus
											  "&:after": { borderBottomColor: "gray" },  // after focus
											},
										  }}
										  InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										  }}
									/>
								</div>
							</div>
							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={submitClick}
								>
									Submit <SaveIcon />
								</CustomButton>
								{/* <Button
                  style={{
                    // marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  // color="primary"
                  onClick={submitClick}
                  endIcon={<SaveIcon />}
                >
                  Submit
                </Button> */}
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{legalEntity.data.status == "Success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{/* Legal Entity set Successfully */}
								{legalEntity.data.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{legalEntity.data.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{/* Something Went Wrong */}
								{legalEntity.data.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{legalEntity.data.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{/* Something Went Wrong */}
								{legalEntity.data.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default LegalEntity;
